import {styled, css} from "styled-components";
import { Link } from "react-router-dom";

export const ContentDetailHeader = styled.div`
    display: grid;
    grid-template: 
        'left right' auto
        'left bottom' auto / fit-content(30%) 1fr;
    column-gap: 30px;
    margin-bottom: 60px;
    padding-top: 30px;
`

export const ContentImageContainer = styled.div`
    min-width: 0;
    grid-area: left;
    box-sizing: border-box;
    width: 204px;
    position: relative;
    
`

export const ContentImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: 4px;
`

export const ContentInfoContainer = styled.div`
    min-width: 0;
    grid-area: right;
    box-sizing: border-box;

`

export const ContentTitleWrapper = styled.div`
    display: flex;
    gap: 40px;
    margin-bottom: 12px;
    align-items: center;
`

export const ContentTitle = styled.h1`
    color: #222;
    font-size: 28px;
    font-weight: 600;
    line-height: 32px;
`

export const ContentStatus = styled.div<{$status: 'COMPLETED' | 'ONGOING' | 'REST'}>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    line-height: 1;
    border-radius: 12px;
    font-weight: 600px;
    height: 25px;
    font-size: 15px;
    color: #FFF;
    cursor: default;
    

    ${({$status}) => {
        switch ($status) {
            case 'COMPLETED':
              return css`
                background-color: #444; // 완결 - 짙은 회색
              `;
            case 'ONGOING':
              return css`
                background-color: #3498db; // 연재중 - 빨강
              `;
            case 'REST':
              return css`
                background-color: #e74c3c; // 휴재 - 파랑
              `;
            default:
              return css`
                background-color: gray;
              `;
          }
    }}
`


export const ContentInfoText = styled.div`
    display: flex;
    margin-bottom: 8px;
`

export const ContentAuthor = styled.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
    padding-right: 10px;
    border-right: 1px solid #e6e6e6;
`

export const ContentSerialDay = styled.div`
    font-size: 14px;
    line-height: 17px;
    padding-left: 10px;
`

export const ContentScoreContainer = styled.div`
    display: flex;  
    margin-bottom: 8px;
`   

export const ContentRatingContainer = styled.div`
    display: flex;
    gap: 5px;
    padding-right: 10px;
    border-right: 1px solid #e6e6e6;
`

export const ContentRatingScore = styled.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
`

export const ContentRatingCount = styled.div`
    margin-left: 5px;
    font-size: 14px;
    line-height: 17px;
`

export const ContentViewCount = styled.div`
    padding-left: 10px;
    font-size: 15px;
    line-height: 17px;
`
export const ContentViewCountName = styled.span`
    font-weight: 500;
    margin-right: 5px;
`
export const ContentDescription = styled.p`
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.5px;
    white-space: pre-line;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    margin-bottom: 8px;
`

export const ContentKeywordContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 15px;

`

export const ContentKeywordItem = styled.button`
    display: inline-block;
    padding: 6px 12px;
    background-color: #F4F4F4;
    font-size: 15px;
    font-weight: 500;
    border-radius: 8px;
    white-space: nowrap;
    line-height: 1;

`

export const ContentLikeBtnContainer = styled.div`


`

export const ContentInterestBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    line-height: 1;
    border-radius: 12px;
    font-weight: 600px;
    height: 25px;
    font-size: 15px;
    color: #fff;
    background-color: var(--accent-color);
`

export const ContentInterestRegisterBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    line-height: 1;
    border-radius: 12px;
    font-weight: 600px;
    height: 25px;
    font-size: 15px;
    color: #69a3ff;
    border: 1px solid #69a3ff;
`

export const ContentLikeBtnText = styled.p`
    margin-left: 5px;
`
export const EpisodeSection = styled.section`
    padding-bottom: 80px;
    border-top: 2px solid #222;
`

export const EpisodeListOption = styled.div`
    display: flex;
    width: 100%;
    padding: 10px 0;
    height: 50px;
    align-items: center;
    justify-content: space-between;
`

export const OptionLeft = styled.div`
    padding-left: 10px;
    display: flex;
`

export const OptionItem = styled.li`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const OptionCheckbox = styled.input`
    width: 15px;
    height: 15px;
    border: 1px solid #eee;
    cursor: pointer;
    border-radius: 4px;
`

export const OptionCheckboxLabel = styled.label`
    vertical-align: top;
    line-height: 18px;
    margin: 0 15px 0 8px;
`

export const FilterBtnDivider = styled.div`
    width: 1px;
    height: 14px;
    margin: 0 7px;
    border-radius: 999px;
    background: #e6e6e6;
`

export const EpisodeSellBtnWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

export const RentalBtn = styled.button`
    display: inline-block;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    white-space: nowrap;
    line-height: 1;
    border: 1px solid #528efa;
    color: #528efa;
`

export const PurchaseBtn = styled.button`
    display: inline-block;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    white-space: nowrap;
    line-height: 1;
    background-color: #528efa;
    color: #FFF;
`

export const ViewBtn = styled.button`
    display: inline-block;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    white-space: nowrap;
    line-height: 1;
    border: 1px solid #528efa;
    color: #528efa;
`

export const OptionRight = styled.div`
    padding-right: 10px;
`

export const EpisodeFilterWrapper = styled.div`
    justify-content: center;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
    display: flex;
`

export const EpisodeFilterBtn = styled.button<{$active: boolean}>`
    color: ${({$active}) => ($active? "#69a3ff" : "#b4b4b4" )};
    font-weight: ${({$active}) => ($active? "500" : "")};
    font-size: 14px;
`

export const EpisodeListWrapper = styled.div`
    position: relative;
`

export const EpisodeItem = styled.div`
    display: flex;
    padding: 0 10px;
    width: 100%;
    overflow: hidden;
    position: relative;
    border-top: 1px dotted #bbb;
    align-items: center;
    justify-content: space-between;
    height: 59px;
`

export const EpisodeItemLeft = styled.div`
    display: flex;
    align-items: center;
`

export const EpisodeThumbnailContainer = styled.div`
    margin-left: 8px;
`

export const EpisodeThumbnailImage = styled.img`

`

export const EpisodeInfoContainer = styled.div`
    margin-left: 8px;
    font-size: 14.5px;
`

export const EpisodeTitleAndNum = styled.div`
    font-weight: 500;
`

export const EpisodeTitle = styled.button`
    margin-left: 5px;
`

export const EpisodeDateAndPurchaseData = styled.div`
    display: flex;
    margin-top: 4px;
    font-size: 14px;
    gap: 10px;
`

export const EpisodeCreateDate = styled.div`
    color: #A5A5A5;
`

export const EpisodePurchaseText = styled.div`
    color: #528efa;
`

export const EpisodeItemRight = styled.div`
`

export const ShowAllBtnContainer = styled.div`
    position: relative;
`

export const ShowAllBtn = styled.button`
    padding: 16px 0 14px 0;
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 6px;
    border: 1px solid #ccc;
    margin-top: 0;
`

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    width: 100%;
`

export const LoadingSpinner = styled.div`
    width: 30px;
    height: 30px;
    border: 3px solid rgba(105, 163, 255, 0.2);
    border-top: 3px solid #69a3ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`

export const NotificationContainer = styled.div<{$show: boolean}>`
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    z-index: 1000;
    opacity: ${({$show}) => ($show ? 1 : 0)};
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
`

export const PurchaseModalOverlay = styled.div<{$open: boolean}>`
    position: fixed;
    inset: 0;
    display: ${({$open}) => ($open ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1600;
    padding: 20px;
`

export const PurchaseModal = styled.div`
    width: 100%;
    max-width: 360px;
    padding: 24px 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    text-align: center;
`

export const PurchaseModalTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 12px;
`

export const PurchaseModalDescription = styled.p`
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    margin-bottom: 20px;
`

export const PurchaseModalActions = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
`

export const ModalGhostButton = styled.button`
    display: inline-block;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    border: 1px solid #d0d0d0;
    background: #fff;
    color: #5a5a5a;
`

